import { TableColumnWidth } from "./TableColumnWidth";

export class FlexColumnWidth extends TableColumnWidth {
  constructor(value: number) {
    super({});
  }
}
